import React, { useState, useCallback } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { range } from '../utils/range';
import styled from 'styled-components';
import firebase from 'firebase/app';

interface Props {
  updatePrivilege: (
    start: firebase.firestore.Timestamp,
    end: firebase.firestore.Timestamp
  ) => void;
  isLoadingUpdate: boolean;
}

const Root = styled.div`
  width: 95%;
  margin: 0 auto;
`;

const Table = styled.table`
  width: 100%;
`;

const Td = styled.td`
  text-align: right;
  width: 30%;
`;

const currentYear = new Date().getFullYear() + 1;
const optionsYear = range(1973, currentYear + 50).map((y) => (
  <option key={y} value={y.toString()}>
    {`${y}年`}
  </option>
));

const optionsMonth = range(1, 13).map((y) => (
  <option key={y} value={y.toString()}>
    {`${y}月`}
  </option>
));

const optionsDate = range(1, 32).map((y) => (
  <option key={y} value={y.toString()}>
    {`${y}日`}
  </option>
));

export const NamesPrivilegeAdd = memoNamed<Props>(
  'NamesPrivilegeAdd',
  (props) => {
    const nowYear = new Date().getFullYear().toString();
    const nowMonth = (new Date().getMonth() + 1).toString();
    const nowDate = new Date().getDate().toString();
    const [startYear, setStartYear] = useState<string>(nowYear);
    const [startMonth, setStartMonth] = useState<string>(nowMonth);
    const [startDate, setStartDate] = useState<string>(nowDate);
    const [endYear, setEndYear] = useState<string>(
      new Date() < new Date(`${nowYear}/2/28`)
        ? nowYear
        : (Number(nowYear) + 1).toString()
    );
    const [endMonth, setEndMonth] = useState<string>('2');
    //TODO うるう年対応
    const [endDate, setEndDate] = useState<string>('28');
    const updateStartYear = useCallback(
      (event: React.ChangeEvent<HTMLSelectElement>) => {
        const _year = event.target.value;
        setStartYear(_year);
      },
      []
    );
    const updateEndYear = useCallback(
      (event: React.ChangeEvent<HTMLSelectElement>) => {
        const _year = event.target.value;
        setEndYear(_year);
      },
      []
    );
    const updateStartMonth = useCallback(
      (event: React.ChangeEvent<HTMLSelectElement>) => {
        const _month = event.target.value;
        setStartMonth(_month);
      },
      []
    );
    const updateEndMonth = useCallback(
      (event: React.ChangeEvent<HTMLSelectElement>) => {
        const _month = event.target.value;
        setEndMonth(_month);
      },
      []
    );
    const updateStartDate = useCallback(
      (event: React.ChangeEvent<HTMLSelectElement>) => {
        const _date = event.target.value;
        setStartDate(_date);
      },
      []
    );
    const updateEndDate = useCallback(
      (event: React.ChangeEvent<HTMLSelectElement>) => {
        const _date = event.target.value;
        setEndDate(_date);
      },
      []
    );

    const buttonUpdatePrivilege = useCallback(() => {
      props.updatePrivilege(
        firebase.firestore.Timestamp.fromDate(
          new Date(`${startYear}/${startMonth}/${startDate}`)
        ),
        firebase.firestore.Timestamp.fromDate(
          new Date(`${endYear}/${endMonth}/${endDate}`)
        )
      );
      setStartYear(nowYear);
      setStartMonth(nowMonth);
      setStartDate(nowDate);
    }, [
      props,
      startYear,
      startMonth,
      startDate,
      endYear,
      endMonth,
      endDate,
      nowYear,
      nowMonth,
      nowDate,
    ]);

    return (
      <Root>
        <Table>
          <tbody>
            <tr>
              <Td>特権開始日:</Td>
              <td>
                <select value={startYear} onChange={updateStartYear}>
                  <option value='none'></option>
                  {optionsYear}
                </select>
                <select value={startMonth} onChange={updateStartMonth}>
                  <option value='none'></option>
                  {optionsMonth}
                </select>
                <select value={startDate} onChange={updateStartDate}>
                  <option value='none'></option>
                  {optionsDate}
                </select>
              </td>
            </tr>
            <tr>
              <Td>特権終了日:</Td>
              <td>
                <select value={endYear} onChange={updateEndYear}>
                  <option value='none'></option>
                  {optionsYear}
                </select>
                <select value={endMonth} onChange={updateEndMonth}>
                  <option value='none'></option>
                  {optionsMonth}
                </select>
                <select value={endDate} onChange={updateEndDate}>
                  <option value='none'></option>
                  {optionsDate}
                </select>
                <button onClick={buttonUpdatePrivilege}>登録</button>
                {props.isLoadingUpdate ? ' 通信中...' : undefined}
              </td>
            </tr>
          </tbody>
        </Table>
      </Root>
    );
  }
);
